module.exports = __webpack_public_path__ + "static/media/HCPsClinical-KOLs.551d1826.jpg";